import { render, staticRenderFns } from "./CompleteUserData.vue?vue&type=template&id=67a97a9c&scoped=true"
import script from "./CompleteUserData.vue?vue&type=script&lang=js"
export * from "./CompleteUserData.vue?vue&type=script&lang=js"
import style0 from "./CompleteUserData.vue?vue&type=style&index=0&id=67a97a9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a97a9c",
  null
  
)

export default component.exports